import { Button, Card, Stack, Typography } from '@org/design-system';
import type { ReactNode } from 'react';
import type { ShadcnLayoutType, ShadcnPlan } from '../types';

const PLAN_RANK: Record<ShadcnPlan, number> = {
  free: 0,
  pro: 1,
  enterprise: 2,
};

export const LAYOUT_PLAN_MAP: Record<'full-page' | 'split-panel' | 'analytics-grid' | 'kanban' | 'tabs', ShadcnPlan> = {
  'full-page': 'free',
  'split-panel': 'pro',
  'analytics-grid': 'pro',
  kanban: 'enterprise',
  tabs: 'enterprise',
};

function normalizeLayoutType(layoutType: ShadcnLayoutType): keyof typeof LAYOUT_PLAN_MAP {
  if (layoutType === 'full') return 'full-page';
  return layoutType as keyof typeof LAYOUT_PLAN_MAP;
}

interface PlanGateProps {
  plan?: ShadcnPlan;
  layoutType: ShadcnLayoutType;
  billingPortalUrl?: string;
  children: ReactNode;
}

export function PlanGate({ plan = 'free', layoutType, billingPortalUrl, children }: PlanGateProps) {
  const requiredPlan = LAYOUT_PLAN_MAP[normalizeLayoutType(layoutType)];
  if (PLAN_RANK[plan] >= PLAN_RANK[requiredPlan]) {
    return <>{children}</>;
  }

  return (
    <Card className="border-border bg-card">
      <Stack gap={4} className="p-6">
        <Typography variant="h4">Upgrade required</Typography>
        <Typography color="muted">
          The <span className="font-medium text-foreground">{layoutType}</span> layout requires the{' '}
          <span className="font-medium text-foreground">{requiredPlan}</span> plan. Your current plan is{' '}
          <span className="font-medium text-foreground">{plan}</span>.
        </Typography>
        {billingPortalUrl ? (
          <div>
            <Button asChild>
              <a href={billingPortalUrl} target="_blank" rel="noreferrer">Open billing portal</a>
            </Button>
          </div>
        ) : null}
      </Stack>
    </Card>
  );
}
